import { Draft, PayloadAction } from '@reduxjs/toolkit'
import { map } from 'lodash'

import { isIn } from '@ahha/utils/@types/typeChecks'

import { LabelingState, Tool } from '@/stores/slices/Labeling/types'
import { POSSIBLE_SHAPE, POSSIBLE_TOOL } from '@/stores/slices/Labeling/const'

import { ToolType } from '@/pages/Labeling/types'

/**
 * 툴바 관련
 */
export const toolReducers = {
  setClass: (state: Draft<LabelingState>, action: PayloadAction<string>) => {
    state.tool.class = action.payload
  },
  setTool: (state: Draft<LabelingState>, action: PayloadAction<Tool>) => {
    if (!POSSIBLE_TOOL.includes(action.payload)) {
      console.error(`${action.payload} is not available tool`)
      return
    }
    state.tool.tool = action.payload

    if (isIn(POSSIBLE_SHAPE, action.payload)) {
      state.tool.shape = action.payload
    }
  },
  setBrush: (state: Draft<LabelingState>, action: PayloadAction<number>) => {
    state.tool.brush = action.payload
    state.tool.tool = ToolType.BRUSH
  },
  setOpacity: (state: Draft<LabelingState>, action: PayloadAction<number>) => {
    state.tool.opacity = Math.min(Math.max(action.payload, 0), 100)
  },
  setMagicWandThreshold: (state: Draft<LabelingState>, action: PayloadAction<number>) => {
    state.tool.magicWandThreshold = action.payload
    state.tool.tool = ToolType.MAGICWAND
  },
  setAutoPixelType: (state: Draft<LabelingState>, action: PayloadAction<'POINT' | 'BOX'>) => {
    state.tool.autoPixelType = action.payload
  },
  toggleBrushAutoFill: (state: Draft<LabelingState>) => {
    state.tool.isBrushAutoFill = !state.tool.isBrushAutoFill
  },
  toggleRgbChannel: (state: Draft<LabelingState>, action: PayloadAction<keyof LabelingState['tool']['rgb']>) => {
    const { all, red, green, blue } = state.tool.rgb
    if (action.payload === 'all') {
      if (all) {
        state.tool.rgb = { all: false, red: false, blue: false, green: false }
      } else {
        state.tool.rgb = { all: true, red: true, blue: true, green: true }
      }
      return
    }
    if (action.payload === 'red') {
      state.tool.rgb = { ...state.tool.rgb, red: !red, all: Boolean(!red && green && blue) }
    }
    if (action.payload === 'green') {
      state.tool.rgb = { ...state.tool.rgb, green: !green, all: Boolean(red && !green && blue) }
    }
    if (action.payload === 'blue') {
      state.tool.rgb = { ...state.tool.rgb, blue: !blue, all: Boolean(red && green && !blue) }
    }
  },
  toggleObjectVisibility: (state: Draft<LabelingState>, action: PayloadAction<string>) => {
    const objectId = action.payload
    const fileId = state.files[state.currentIndex]?._id
    if (fileId) {
      state.annotation[fileId] = {
        ...state.annotation[fileId],
        // eslint-disable-next-line react/forbid-prop-types
        object: map(state.annotation[fileId].object, (o) => (o.id === objectId ? {
          ...o,
          isVisible: o.isVisible === false,
        } : o)),
      }
    }
  },
  setTracking: (state: Draft<LabelingState>, action: PayloadAction<{ isTracking: boolean, includeText?: boolean }>) => {
    state.tool.stamp = action.payload
  },
  updatePropmptImageIds: (state: Draft<LabelingState>, action: PayloadAction<string[]>) => {
    state.promptImageIds = action.payload
  },
  setIsRunningSemiAutoLabeling: (state: Draft<LabelingState>, action: PayloadAction<boolean>) => {
    state.isRunningSemiAutoLabeling = action.payload
  },
}
